import apiClient from '../utils/apiClient';

export const getOnboarding = async () => (await apiClient.get('/api/onboarding')).data;
export const setOnboardingStep = async (step) => (await apiClient.patch('/api/onboarding/step', { step })).data;
export const saveCompanyDefaults = async (payload) => (await apiClient.put('/api/onboarding/company', payload)).data;
export const inviteTeam = async (invites) => (await apiClient.post('/api/onboarding/team', { invites })).data;
export const completeOnboarding = async () => (await apiClient.post('/api/onboarding/complete')).data;
export const getChecklist = async () => (await apiClient.get('/api/onboarding/checklist')).data;
export const dismissChecklist = async () => (await apiClient.post('/api/onboarding/dismiss')).data;
